import React, { useState } from 'react';
import { Download, FileDown, FileText } from 'lucide-react';
import './AdminPages.css';

const BulkExport = () => {
  const [exportFormat, setExportFormat] = useState('json');
  const [dateRange, setDateRange] = useState('last-30-days');
  const [status, setStatus] = useState('');

  const handleExport = async () => {
    try {
      setStatus('Preparing export...');
      const queryParams = new URLSearchParams({
        format: exportFormat,
        dateRange: dateRange,
      });
      const response = await fetch(`/api/work-orders/bulk/export?${queryParams}`, {
        method: 'GET',
      });
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `work-orders-export-${Date.now()}.${exportFormat === 'excel' ? 'xlsx' : 'json'}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      setStatus('Export completed successfully!');
    } catch (error) {
      setStatus('Export failed: ' + error.message);
    }
  };

  return (
    <div className="admin-page">
      <div className="page-header">
        <h1><Download size={24} /> Bulk Export Work Orders</h1>
      </div>

      <div className="form-section">
        <h3>Export Options</h3>
        <div className="form-group">
          <label>Format</label>
          <div className="option-group">
            <label className="radio-option">
              <input
                type="radio"
                value="json"
                checked={exportFormat === 'json'}
                onChange={(e) => setExportFormat(e.target.value)}
              />
              <FileText size={18} /> JSON
            </label>
            <label className="radio-option">
              <input
                type="radio"
                value="excel"
                checked={exportFormat === 'excel'}
                onChange={(e) => setExportFormat(e.target.value)}
              />
              <FileDown size={18} /> Excel (XLSX)
            </label>
          </div>
        </div>

        <div className="form-group">
          <label>Date Range</label>
          <select
            value={dateRange}
            onChange={(e) => setDateRange(e.target.value)}
          >
            <option value="last-7-days">Last 7 Days</option>
            <option value="last-30-days">Last 30 Days</option>
            <option value="last-90-days">Last 90 Days</option>
            <option value="all">All Time</option>
          </select>
        </div>
      </div>

      <div className="actions">
        <button className="btn btn-success" onClick={handleExport}>
          <Download size={16} /> Export Now
        </button>
      </div>

      {status && (
        <div className={`status-message ${status.includes('successfully') ? 'success' : 'error'}`}>
          {status}
        </div>
      )}
    </div>
  );
};

export default BulkExport;
